/**
 * Cart slice
 * @exports
 */

import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";

// Helper function to check if cart items allow maintenance plans to be added
const isAllowedMaintenances = (items) => {
    if (items.length === 0) {
        return null;
    }

    if (
        items.some((item) => {
            return item.type === "maintenance";
        })
    ) {
        // console.log("cart has maintenance");
        return true;
    } else {
        // console.log("cart does not has maintenance");
        return false;
    }
};

// Initial state for cart slice
const initialState = {
    allowedMaintenances: null,
    error: null,
};

// Create the cart slice with name, initial state, reducers, and extra reducers
export const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        // Set allowedMaintenances state to true
        setAllowedMaintenances: (state) => {
            state.allowedMaintenances = true;
        },
        // Set allowedMaintenances state to false
        removeAllowedMaintenances: (state) => {
            state.allowedMaintenances = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle fulfilled addProduct action from apiSlice
            .addMatcher(
                apiSlice.endpoints.addProduct.matchFulfilled,
                (state, response) => {
                    // console.log("cartSlice addProduct fullfiled", isAllowedMaintenances(response.payload.items));
                    state.allowedMaintenances = isAllowedMaintenances(
                        response.payload.items
                    );
                }
            )
            // Handle fulfilled deleteProduct action from apiSlice
            .addMatcher(
                apiSlice.endpoints.deleteProduct.matchFulfilled,
                (state, response) => {
                    // console.log("cartSlice deleleProduct fullfiled", isAllowedMaintenances(response.payload.items));
                    state.allowedMaintenances = isAllowedMaintenances(
                        response.payload.items
                    );
                }
            )
            // Handle fulfilled getCart action from apiSlice
            .addMatcher(
                apiSlice.endpoints.getCart.matchFulfilled,
                (state, response) => {
                    // console.log("cartSlice getCart fullfiled", isAllowedMaintenances(response.payload.items));
                    state.allowedMaintenances = isAllowedMaintenances(
                        response.payload.items
                    );
                }
            );
    },
});

export { isAllowedMaintenances };

// Export the cartSlice actions
export const { setAllowedMaintenances, removeAllowedMaintenances } =
    cartSlice.actions;

// Export the cartSlice reducer as the default export
export default cartSlice.reducer;
